
export default {
    fields: [
        {
            type: 'checkbox',
            name: 'stepIdsToDelete'
        }
    ]
};


// WEBPACK FOOTER //
// ./public/pages/ViewAllPlatforms/DeleteSteps/deleteStepsFormConfig.js